import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Rgpc7 = props => (
    <section id="rgpc-section7" className="my pt-5 white-bg">
        <Container>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5 blue">{props.t('services:rgpc:section-7.title')}</h2>
            <p className='mb-5'>{props.t('services:rgpc:section-7.text')}</p>
            {/* Text content */}
            <div className='mb-5'>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:rgpc:section-7.1.title')}</h3>
                </div>
                <h4 className='h6 fw-600 light-orange'>{props.t('services:rgpc:section-7.1.subtitle.1.title')}</h4>
                <p>{props.t('services:rgpc:section-7.1.subtitle.1.text')}</p>
                <h4 className='h6 fw-600 light-orange'>{props.t('services:rgpc:section-7.1.subtitle.2.title')}</h4>
                <p>{props.t('services:rgpc:section-7.1.subtitle.2.text')}</p>
            </div>
            {/* Text content */}
            <div>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:rgpc:section-7.2.title')}</h3>
                </div>
                <h4 className='h6 fw-600 light-orange'>{props.t('services:rgpc:section-7.2.subtitle.1.title')}</h4>
                <p>{props.t('services:rgpc:section-7.2.subtitle.1.text')}</p>
                <h4 className='h6 fw-600 light-orange'>{props.t('services:rgpc:section-7.2.subtitle.2.title')}</h4>
                <p className='mb-0'>{props.t('services:rgpc:section-7.2.subtitle.2.text')}</p>
            </div>
        </Container>
    </section>
);


export default Rgpc7;